import { PublicHttpClient } from './PublicHttpClient';

const clientsRegistry = new Map<object, PublicHttpClient>();

export function registerClient(clientClass: object, client: PublicHttpClient): void {
  clientsRegistry.set(clientClass, client);
}

export function getClient(clientClass: object): PublicHttpClient | undefined {
  return clientsRegistry.get(clientClass);
}
